export default __webpack_public_path__ + "static/media/27.fca3c911.PNG";